import { useTranslations } from "@jugl-web/utils";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import { useEmailAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/EmailAccountProvider/useEmailAccount";
import React from "react";
import { ManageAccountsDrawerScreenToParametersMap } from "../../../../types";
import { DomainTable } from "./components/DomainTable";

export const DomainSection: React.FC = () => {
  const { t } = useTranslations();
  const { transitionTo } =
    useScreenTransitionManager<ManageAccountsDrawerScreenToParametersMap>();
  const { emailAccount } = useEmailAccount();

  if (!emailAccount || emailAccount.type !== "raw" || !emailAccount.metadata) {
    return null;
  }

  const { metadata } = emailAccount;

  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-solid border-dark-100 bg-white p-8 shadow-[0_2px_4px_rgba(0,0,0,0.08)] max-lg:p-5">
      <span className="ml-2 font-secondary text-lg font-medium text-black max-lg:text-base">
        {t({
          id: "client-support-page.domain",
          defaultMessage: "Domain",
        })}
      </span>

      <DomainTable
        displayEmail={metadata.client_email || ""}
        forwardingStatus={
          metadata.email_forwarding_verified ? "verified" : "notVerified"
        }
        domainAuthStatus={
          metadata.domain_auth_enabled
            ? metadata.domain_auth_verified
              ? "verified"
              : "pending"
            : null
        }
        onForwardingSetupClick={() =>
          transitionTo({ name: "emailForwardingSetup" })
        }
        onDomainAuthSetupClick={() =>
          transitionTo({ name: "emailDomainAuthSetup" })
        }
      />
    </div>
  );
};
